import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': {
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          height: 48
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        containedPrimary: {
          boxShadow: 'none'
        },
        containedSecondary: {
          boxShadow: 'none'
        },
        outlined: {
          borderWidth: 1
        },
        outlinedPrimary: {
          borderColor: alpha(theme.palette.primary.main, 0.4),
          '&:hover': {
            borderColor: theme.palette.primary.dark,
            backgroundColor: alpha(theme.palette.primary.main, 0.06)
          }
        },
        outlinedSecondary: {
          borderColor: theme.palette.grey[300],
          color: theme.palette.text.primary,
          '&:hover': {
            borderColor: theme.palette.grey[400],
            backgroundColor: theme.palette.action.hover
          }
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  };
}
